<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer>
            <header class="mt-10 mb-20 global-text text-center">
                <StoryblokRichText :doc="blok?.header" />
            </header>
            <div class="flex flex-wrap items-center -m-12">
                <div class="w-5/12 p-12 global-text max-[769px]:w-full">
                    <StoryblokRichText :doc="blok?.description" />
                </div>
                <div class="w-7/12 p-12 max-[769px]:w-full">
                    <img
                        v-motion-slide-visible-once-bottom
                        :src="blok?.chart1.filename"
                        :alt="blok?.chart1.alt"
                    >
                </div>
                <div class="w-full p-12">
                    <img
                        v-motion-slide-visible-once-bottom
                        :src="blok?.chart2.filename"
                        :alt="blok?.chart2.alt"
                    >
                </div>
            </div>
        </UiContainer>
    </section>
</template>
